export const SgaOddStatusDto = {
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED',
    UNAVAILABLE: 'UNAVAILABLE',
} as const;
export type SgaOddStatusDto = typeof SgaOddStatusDto[keyof typeof SgaOddStatusDto];

export type SgaOddPriceLegDto = {
    // Localised full name for this leg ready for displaying, concatenation of marketName + oddName
    // e.g. "Total goals: Over 1.5"
    name: string;

    // Betting status of this particular leg
    status: SgaOddStatusDto;

    marketUuid: string;

    // Localised market name of this leg.
    // e.g. "Total goals"
    marketName: string;

    oddUuid: string;

    // Localised odd/outcome name of this leg.
    // e.g. "Over 1.5"
    oddName: string;
};

export type SgaOddPriceDto = {
    // Unique UUID generated from the component IDs given in the request
    sgaUuid: string;

    // Price for this SGA
    price: number;

    // String representing the status of this SGA, (i.e. is it possible to bet on it)
    status: SgaOddStatusDto;

    // String representing the outcome ID of this SGA combination.
    outcomeId: string;

    // String representing the market ID of this SGA combination.
    // It's essentially a hardcoded market ID per sport.
    marketId: string;

    legs: SgaOddPriceLegDto[];
};
